import { render, staticRenderFns } from "./Gender.vue?vue&type=template&id=0c34e7a4&scoped=true&"
import script from "./Gender.vue?vue&type=script&lang=js&"
export * from "./Gender.vue?vue&type=script&lang=js&"
import style0 from "./Gender.vue?vue&type=style&index=0&id=0c34e7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34e7a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c34e7a4')) {
      api.createRecord('0c34e7a4', component.options)
    } else {
      api.reload('0c34e7a4', component.options)
    }
    module.hot.accept("./Gender.vue?vue&type=template&id=0c34e7a4&scoped=true&", function () {
      api.rerender('0c34e7a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Gender.vue"
export default component.exports